export const artist = {
  'Verified Artist': 'Artista Verificado',
  Popular: 'Popular',
  Discography: 'Discografia',
  'Popular Releases': 'Lançamentos Populares',
  'Show More': 'Mostrar Mais',
  'Appears on': 'Aparece em',
  'Popular Albums': 'Álbuns Populares',
  Singles: 'Singles',
  Albums: 'Álbuns',
  'Singles and EPs': 'Singles e EPs',
};
